//
// Shop: Global events on add\remove product to cart
//

( function($, waTheme) {

    var Cart = (function($) {

        var change_functions = [];

        Cart = function(options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$items = that.$wrapper.find(".b-cart__items");
            that.$badge = that.$wrapper.find(".b-cart__badge");
            that.$count = that.$wrapper.find(".b-cart__count");
            that.$total = that.$wrapper.find(".b-cart__total");

            // VARS

            // DYNAMIC VARS
            that.count = options["count"];

            // INIT
            that.initClass();
        };

        Cart.prototype.initClass = function() {
            var that = this;

            $(document).on("cartIsChanged", function(event, data) {
                that.update(data);
            });

            $(document).on("click", ".js-remove-from-cart", function() {
                var product_id = $(this).parents(".b-cart__item").data("product-id");
                that.onRemove($(this).parents(".b-cart__item"), product_id);
            });
        };

        /**
         * @param {Object} data
         * */
        Cart.prototype.update = function(data) {
            var that = this;

            if (data.count > 0) {
                that.$count.text(data.count);
                that.$badge.removeClass("d-none");
                that.count = (data.count);
                toggle(true);

                if (data.total) {
                    that.$total.html(data.total);
                }

                if (data.items) {
                    that.updateItems(data.items);
                }
            } else {
                that.$count.text(0);
                that.$badge.addClass("d-none");
                that.count = 0;
                toggle();
            }

            function toggle(show) {
                var dropdown_class = "invisible";

                if (show) {
                    that.$wrapper.find(".b-cart__dropdown-menu").removeClass(dropdown_class);
                } else {
                    that.$wrapper.find(".b-cart__dropdown-menu").addClass(dropdown_class);
                }
            }

            $.each(change_functions, function(index, func) {
                try {
                    func(that);
                } catch(e) {
                    console.log(e.message);
                }
            });
        };

        Cart.prototype.updateItems = function(items) {
            var that = this,
                html = "";

            for (let i = 0; i < items.length; i++) {

                if (items[i]["image_url"] === null) {
                    var image = `${window.waTheme.theme.url}assets/img/svg/empty_photo.svg`;
                } else {
                    var image = items[i]["image_url"];
                }

                html += `<div class="b-cart__item" data-product-id="${items[i]["id"]}">
                            <a class="b-cart__item-image" href="${items[i]["frontend_url"]}">
                                <img class="b-lazyload rounded" data-src="${image}" alt="${items[i]["name"]}">
                            </a>
                            <a class="b-cart__item-content link-emphasis" href="${items[i]["frontend_url"]}">
                                <div class="b-cart__item-name">${items[i]["name"]}</div>
                                <div class="b-cart__item-price text-emphasis">
                                    ${items[i]["full_price"]}
                                </div>
                            </a>
                            <button class="btn btn-gray-theme-link p-0 icon icon-sm ms-auto align-self-start js-remove-from-cart" type="button">
                                ${window.waTheme.icons["trash"]}
                            </button>
                         </div>`;
            }

            that.$items.html(html);

            //
            waTheme.init.site.ImageLazyLoad.update();

        };

        /**
         * @param {Function} func
         * */
        Cart.prototype.onChange = function(func) {
            if (typeof func === "function") {
                change_functions.push(func);
            }
        };

        Cart.prototype.onRemove = function($product, product_id) {
           var that = this,
               data = {
                   html: 1,
                   items: 1,
                   id: product_id
               };

           $.post(window.waTheme.cart_url + "delete/", data, function (response) {
               // console.log(response);
               //
               $product.remove();
               //
               that.update(response["data"]);
               //
               that.$total.html(response["data"]["total"]);

           }, "json");
        };

        return Cart;

    })($);

    waTheme.init.shop.Cart = Cart;

    var $wrapper = $(".b-cart");
    if ($wrapper.length) {
        waTheme.apps["shop"].cart = new window.waTheme.init.shop.Cart({
            $wrapper: $wrapper
        });
    }

})(jQuery, window.waTheme);
